// semeia-disable-reexport
import { isTesting } from "@embroider/macros";

const computeKey = key => `${isTesting() ? "test-wise" : "wise"}:${key}`;

const getItem = (key: string): string | null => {
  const result = window.localStorage?.getItem(key);
  return result ? (result == "undefined" ? null : result) : null;
};

const getItemFromLocalStorage = (key: string): string | null => {
  return getItem(computeKey(key));
};

const getItemFromLocalStorageWithoutPrefix = (key: string): string | null => {
  return getItem(key);
};

const setItem = <T>(key: string, value: T): void => {
  window.localStorage?.setItem(
    key,
    typeof value === "string" ? value : JSON.stringify(value)
  );
};

const setItemInLocalStorage = <T>(key: string, value: T): void => {
  setItem(computeKey(key), value);
};

const setItemInLocalStorageWithoutPrefix = <T>(key: string, value: T): void => {
  setItem(key, value);
};

const removeItemFromLocalStorage = (key: string): void => {
  window.localStorage?.removeItem(computeKey(key));
};

const getKeysFromLocalStorage = (): string[] => {
  return Object.keys(window.localStorage);
};

const isLocalStorageAvailable = (): boolean => {
  return Boolean(window.localStorage);
};

export {
  computeKey,
  getItemFromLocalStorage,
  getItemFromLocalStorageWithoutPrefix,
  getKeysFromLocalStorage,
  isLocalStorageAvailable,
  removeItemFromLocalStorage,
  setItemInLocalStorage,
  setItemInLocalStorageWithoutPrefix
};
